const ContactSection = () => {
  return (
    <section className="py-24 bg-neutral-50">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-secondary/10 rounded-full mb-6">
            <span className="text-secondary font-semibold text-sm">İletişim</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-6 font-heading">
            Bize Ulaşın
          </h2>
          <p className="text-neutral-600 text-lg max-w-3xl mx-auto">
            2. el bilgisayar alım satım, laptop tamiri ve teknik servis için hemen iletişime geçin
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Map */}
          <div className="h-[500px] rounded-xl overflow-hidden shadow-card">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3009.7547!2d28.9784!3d41.0082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDAwJzI5LjUiTiAyOMKwNTgnNDIuMiJF!5e0!3m2!1str!2str!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="ES Bilgisayar Konum"
            ></iframe>
          </div>

          {/* Contact Info & Form */}
          <div className="space-y-8">
            {/* Contact Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <a
                href="tel:+905065376985"
                className="flex items-center space-x-4 p-6 bg-white rounded-xl shadow-card hover:shadow-card-hover transition-all cursor-pointer group"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-secondary/10 rounded-xl group-hover:bg-secondary transition-colors">
                  <i className="ri-phone-line text-2xl text-secondary group-hover:text-white transition-colors"></i>
                </div>
                <div>
                  <p className="text-sm text-neutral-500 mb-1">Telefon</p>
                  <p className="font-semibold text-primary">0506 537 69 85</p>
                </div>
              </a>

              <a
                href="https://wa.me/905065376985"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-4 p-6 bg-white rounded-xl shadow-card hover:shadow-card-hover transition-all cursor-pointer group"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-whatsapp/10 rounded-xl group-hover:bg-whatsapp transition-colors">
                  <i className="ri-whatsapp-line text-2xl text-whatsapp group-hover:text-white transition-colors"></i>
                </div>
                <div>
                  <p className="text-sm text-neutral-500 mb-1">WhatsApp</p>
                  <p className="font-semibold text-primary">Mesaj Gönder</p>
                </div>
              </a>

              <a
                href="mailto:info@esbilgisayar.com"
                className="flex items-center space-x-4 p-6 bg-white rounded-xl shadow-card hover:shadow-card-hover transition-all cursor-pointer group"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-accent/10 rounded-xl group-hover:bg-accent transition-colors">
                  <i className="ri-mail-line text-2xl text-accent group-hover:text-white transition-colors"></i>
                </div>
                <div>
                  <p className="text-sm text-neutral-500 mb-1">E-posta</p>
                  <p className="font-semibold text-primary text-sm">info@esbilgisayar.com</p>
                </div>
              </a>

              <div className="flex items-center space-x-4 p-6 bg-white rounded-xl shadow-card">
                <div className="w-14 h-14 flex items-center justify-center bg-primary/10 rounded-xl">
                  <i className="ri-map-pin-line text-2xl text-primary"></i>
                </div>
                <div>
                  <p className="text-sm text-neutral-500 mb-1">Adres</p>
                  <p className="font-semibold text-primary text-sm">İstanbul, Türkiye</p>
                </div>
              </div>
            </div>

            {/* Working Hours */}
            <div className="bg-white rounded-xl p-8 shadow-card">
              <h3 className="text-xl font-bold text-primary mb-6 flex items-center space-x-2">
                <i className="ri-time-line text-secondary"></i>
                <span>Çalışma Saatleri</span>
              </h3>
              <div className="space-y-3">
                <div className="flex items-center justify-between py-2 border-b border-neutral-100">
                  <span className="text-neutral-600">Pazartesi - Cumartesi</span>
                  <span className="font-semibold text-primary">09:00 - 19:00</span>
                </div>
                <div className="flex items-center justify-between py-2">
                  <span className="text-neutral-600">Pazar</span>
                  <span className="font-semibold text-secondary">Kapalı</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;